import React, { useState } from "react";
import axios from "axios";

const RegisterForm = ({ onRegister }) => {
  const [registerData, setRegisterData] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setRegisterData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const registerUser = (event) => {
    event.preventDefault();

    const { name, email, password, confirmPassword } = registerData;

    if (password !== confirmPassword) {
      alert("Passwords do not match");
      return;
    }

    axios
      .post("https://journey-scape-main.vercel.app/api/auth/adminregister", {
        name,
        email,
        password,
      })
      .then((response) => {
        const { success, message } = response.data;
        if (success) {
          alert(message);
          onRegister(name);
        } else {
          alert(message);
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 409) {
          alert(error.response.data.message);
        } else {
          console.error(error);
          alert("Failed to register user: " + error.message);
        }
      });
  };

  return (
    <form id="registerForm" onSubmit={registerUser}>
      <div className="form-group">
        <input
          type="text"
          className="form-control"
          id="registerName"
          name="name"
          value={registerData.name}
          onChange={handleInputChange}
          required
        />
        <label htmlFor="registerName" className="animated-label">
          Name
        </label>
      </div>
      <div className="form-group">
        <input
          type="email"
          className="form-control"
          id="registerEmail"
          name="email"
          value={registerData.email}
          onChange={handleInputChange}
          required
        />
        <label htmlFor="registerEmail" className="animated-label">
          Email
        </label>
      </div>
      <div className="form-group">
        <input
          type="password"
          className="form-control"
          id="registerPassword"
          name="password"
          value={registerData.password}
          onChange={handleInputChange}
          required
        />
        <label htmlFor="registerPassword" className="animated-label">
          Password
        </label>
      </div>
      <div className="form-group">
        <input
          type="password"
          className="form-control"
          id="registerConfirmPassword"
          name="confirmPassword"
          value={registerData.confirmPassword}
          onChange={handleInputChange}
          required
        />
        <label htmlFor="registerConfirmPassword" className="animated-label">
          Confirm Password
        </label>
      </div>
      <button type="submit" className="btn btn-primary btn-block w-100">
        Register
      </button>
    </form>
  );
};

export default RegisterForm;
